import {mapState} from "vuex";
import {localStorageKey} from "@/api/config";
import util from "@/mixins/util";

import EventBus from "@/utils/event-bus";
import {logout} from "@/utils/logout";

const TEMP_PASSWORD_LOGIN_FLOW_KEY = localStorageKey + 'tempPasswordLoginFlow';

export default {
    data() {
        return {
            subscriptData: [],
        }
    },
    computed: {
        ...mapState({
            UserInfo: state => state.userInfo.UserInfo,
        })
    },
    created() {

    },
    mounted() {
        this.checkTempPassword();
        this.checkSubscript();
        EventBus.$on('checkNextSubscript', this.checkNextSubscript);
    },
    beforeUnmount() {
        EventBus.$off('checkNextSubscript',);
    },
    methods: {
        consumeTempPasswordLoginFlow() {
            const isInitialLogin = window.localStorage.getItem(TEMP_PASSWORD_LOGIN_FLOW_KEY) === 'true';
            window.localStorage.removeItem(TEMP_PASSWORD_LOGIN_FLOW_KEY);
            return isInitialLogin;
        },
        checkTempPassword() {
            try {
                this.$api.$member.checkTempPasswordStatus().then(res => {
                    if (res.code === 1 && res.result && res.result.data === true) {
                        this.consumeTempPasswordLoginFlow();
                        this.createAlert({
                            title: '임시 비밀번호 발급 안내',
                            content: '임시 비밀번호가 발급 되었습니다.<br>자동 로그아웃 처리되며 다시 로그인 후 비밀번호를 변경해주세요.',
                            btnText: '닫기',
                            hide: () => {
                                logout(this);
                            }
                        });
                        return;
                    }
                    this.consumeTempPasswordLoginFlow();
                })
            } catch (e) {
                console.log(e);
            }
        },
        checkSubscript() {
            let params = {}
            try {
                this.$api.$subscript.getSubscript(params).then(res => {
                    if (!util.isEmpty(res.result.list)) {
                        this.subscriptData = res.result.list;
                        this.openSubscript(0);
                    }
                })
            } catch (e) {
                console.log(e);
            }
        },
        checkNextSubscript(index) {
            if (index < this.subscriptData.length) {
                this.$nextTick(() => {
                    this.openSubscript(index);
                })
            }
        },
        openSubscript(index) {
            this.$vfm.show('subscript-modal', {subscriptData: this.subscriptData[index], index: index});
        },
    },
}
